import React, { useState, useEffect } from "react";
import * as Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import ColoumnsHeader from "../../generic/ColoumnsHeader";
import { DBStatistics } from "../../../../../Containers/vendor/DashBoard/DBCosntants";
import { addDays, getDiffBtnDates } from "../../../../utils/dateCalculater";
import { convertRS, handleTickInterval, weeklyDataValue } from "../../utlits";
import NoDataFound from "../../generic/NoDataFound";

export interface ILSAreaGraphProps {
  loginData: Array<DBStatistics>;
  handleDownloadBtn: () => void;
}

const LSAreaGraph: React.FC<ILSAreaGraphProps> = (props) => {
  const defaultOptionsColor = Highcharts.getOptions().colors;
  const defaultColor = Highcharts.Color;
  const [disableMenu, setDisableMenu] = useState<boolean>(false);
  const [loginHit, setLoginHit] = useState<any>({
    category: [],
    data: [],
    tickInterval: 0,
  });

  const setUpChart = async (loginData: any) => {
    if (loginData.length > weeklyDataValue) {
      let firstDate = loginData ? loginData[0].key : "";
      let lastDate = loginData ? loginData[loginData.length - 1].key : "";
      let totalWeeks = await getDiffBtnDates(firstDate, lastDate);
      if (totalWeeks % 1 !== 0) {
        totalWeeks = Math.floor(totalWeeks) + 1;
      }
      // Set TickInterval function ;

      let key: Array<string> = [];
      let value: any = [];
      let getNtHitsPrDay = [...loginData];

      let dateOne = firstDate;
      for (let i = 0; i <= totalWeeks; i++) {
        // Get first Date and adding seven days of getNtHitsPrDay array
        let seventhDay = await addDays(dateOne, 6);

        // eslint-disable-next-line no-loop-func
        let customData = getNtHitsPrDay.filter((date: any) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });

        if (customData.length > 0) {
          let totalVal: any = 0;
          for (let j = 0; j < customData.length; j++) {
            totalVal += parseInt(customData[j].val);
          }
          value.push([
            `${moment(dateOne).format("YYYY-MM-DD")} to ${moment(
              seventhDay
            ).format("YYYY-MM-DD")}`,
            parseInt(totalVal),
          ]);
        } else {
          if (moment(dateOne).format("YYYY-MM-DD") <= lastDate) {
            value.push(0);
          }
        }
        if (moment(dateOne).format("YYYY-MM-DD") <= lastDate) {
          if (lastDate < moment(seventhDay).format("YYYY-MM-DD")) {
            key.push(`${moment(dateOne).format("YYYY-MM-DD")} to ${lastDate}`);
          } else {
            key.push(
              `${moment(dateOne).format("YYYY-MM-DD")} to ${moment(
                seventhDay
              ).format("YYYY-MM-DD")}`
            );
          }
        }
        dateOne = await addDays(seventhDay, 1);
      }

      let getTickInterval = await handleTickInterval(key.length);

      if (key.length > 0 || value.length > 0) {
        setLoginHit({
          category: key,
          data: value,
          tickInterval: getTickInterval,
        });
      }
    } else {
      let key: any = [];
      let value: any = [];
      loginData.forEach((api: any) => {
        key.push(api.key);
        value.push(parseInt(api.val));
      });
      let getTickInterval = await handleTickInterval(key.length);

      if (key.length > 0 || value.length > 0) {
        setLoginHit({
          tickInterval: getTickInterval,
          category: key,
          data: value,
        });
      }
    }
  };

  useEffect(() => {
    if (props.loginData.length > 0) {
      setDisableMenu(false);
      setUpChart(props.loginData);
    } else {
      setDisableMenu(true);
      setLoginHit({
        category: [],
        data: [],
      });
    }
  }, [props.loginData]);

  const options = {
    chart: {
      type: "area",
      height: "300px",
      marginBottom: 55,
    },

    title: "",
    credits: {
      enabled: false,
    },
    legend: false,

    xAxis: {
      allowDecimals: false,
      margin: "0",
      crosshair: true,
      categories: loginHit.category,
      tickInterval: loginHit.tickInterval,
      tickPixelInterval: 300,
      labels: {
        formatter: function (this: any): any {
          if (this.value.includes("to")) {
            let splitVal = this.value.split("to");
            return `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
              splitVal[1]
            ).format("DD MMM 'YY")}`;
          } else {
            return moment(this.value).format("DD MMM 'YY"); // clean, unformatted number for year
          } // clean, unformatted number for year
        },
      },
    },
    yAxis: {
      title: "",
      margin: "0",

      padding: "0",
      labels: {
        formatter: function (this: any): any {
          let val = convertRS(this.value, 0);
          return val;
        },
      },
    },
    tooltip: {
      formatter: function (this: any): string {
        let tooltipVal = "";
        if (this.x.includes("to")) {
          let splitVal = this.x.split("to");
          tooltipVal = `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
            splitVal[1]
          ).format("DD MMM 'YY")}`;
        } else {
          tooltipVal = moment(this.x).format("DD MMM 'YY");
        }
        return `<p><b>${tooltipVal}</b></p> </br> <b><span style="color:${this.series.color}">${this.series.name}</span> : ${this.y}</b>`;
      },
      borderWidth: 0,
      backgroundColor: "#fff",
      borderRadius: 4,
    },
    plotOptions: {
      series: {
        color: "#1c9ad6",
        fillColor: {
          linearGradient: [1, 2, 2, 210],
          stops: [
            [0, defaultOptionsColor ? defaultOptionsColor[0] : ""],
            [
              1,
              new defaultColor(
                defaultOptionsColor ? defaultOptionsColor[0] : ""
              )
                .setOpacity(0)
                .get("rgba"),
            ],
          ],
        },
      },

      area: {
        marker: {
          enabled: true,
          symbol: "circle",
          radius: 2,
          states: {
            hover: {
              enabled: true,
            },
          },
        },
      },
    },
    series: [
      {
        showInLegend: false,
        name: "Login Statistics",

        data: loginHit.data ? loginHit.data : [],
      },
    ],
  };

  return (
    <>
      <ColoumnsHeader
        title={"Login Statistics "}
        isDownload={true}
        disableMenu={disableMenu}
        handleDownloadBtn={props.handleDownloadBtn}
      />
      {/* <div className="col_body"> */}
      {props.loginData && props.loginData.length > 0 ? (
        <HighchartsReact highcharts={Highcharts} options={options} />
      ) : (
        <NoDataFound />
      )}
      {/* </div> */}
    </>
  );
};

export default LSAreaGraph;
